import { toneFor, PROVINCE_NAMES } from "../lib/tone";

export const TILES = {
  YT: [30, 30, 100, 120], NT: [140, 30, 150, 120], NU: [300, 10, 220, 140],
  BC: [30, 160, 100, 140], AB: [140, 160, 85, 140], SK: [235, 160, 80, 140], MB: [325, 160, 90, 140],
  ON: [425, 175, 125, 155], QC: [560, 120, 125, 170], NL: [695, 95, 85, 95],
  NB: [580, 300, 66, 44], PE: [656, 300, 64, 30], NS: [656, 338, 90, 36],
};

export const CanadaTileMap = ({ provinces, selected, onSelect }) => {
  const byCode = Object.fromEntries((provinces || []).map((p) => [p.code, p]));
  return (
    <div data-testid="canada-map-container" className="w-full">
      <div className="overflow-x-auto">
      <svg viewBox="0 0 800 390" className="h-auto w-full min-w-[560px]" role="group" aria-label="Map of Canadian provinces and territories">
        {Object.entries(TILES).map(([code, [x, y, w, h]]) => {
          const p = byCode[code];
          const tone = toneFor(p ? p.score : 50);
          const active = selected === code;
          return (
            <g
              key={code}
              data-testid={`map-province-path-${code}`}
              className="map-tile cursor-pointer"
              onClick={() => onSelect(active ? null : code)}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onSelect(active ? null : code)}
              tabIndex={0}
              role="button"
              aria-pressed={active}
              aria-label={`${PROVINCE_NAMES[code]}: ${p ? p.score : "no data"}`}
            >
              <title>{`${PROVINCE_NAMES[code]} — ${p ? p.score : "–"} (${tone.label})`}</title>
              <rect className={`tile-${tone.key}`} x={x} y={y} width={w} height={h} rx={14} fill={tone.soft} stroke={active ? "#0C4A6E" : tone.hex} strokeWidth={active ? 4 : 1.5} />
              {h < 70 ? (
                <text x={x + w / 2} y={y + h / 2 + 5} textAnchor="middle" className="fill-slate-800 font-heading text-[13px] font-semibold">
                  {code} {p ? Math.round(p.score) : ""}
                </text>
              ) : (
                <text x={x + 12} y={y + 26} className="fill-slate-800 font-heading text-[17px] font-semibold">{code}</text>
              )}
              {h >= 70 && (
                <text x={x + 12} y={y + h - 14} className={`tile-score-${tone.key} font-mono text-[15px]`} fill={tone.hex === "#f59e0b" ? "#92400e" : tone.hex === "#10b981" ? "#065f46" : "#9f1239"}>
                  {p ? Math.round(p.score) : "–"}
                </text>
              )}
            </g>
          );
        })}
      </svg>
      </div>
      <p className="mt-2 text-xs text-slate-500">Simplified tile map. Tap a region to focus its gauge and headlines.</p>
    </div>
  );
};
